export default "__VITE_ASSET__7a2a1355__"